import React from 'react'
import { Box } from '@mui/system'

const DEFAULT_SRC = '/assets/images/logos/identitech-logo.png'

const MatxLogo = ({ src = DEFAULT_SRC }) => {
    return (
        <Box
            component="img"
            alt="Logo"
            src={src || DEFAULT_SRC}
            sx={{
                width: '60%',
                maxWidth: { xs: 140, sm: 180, md: 220 },
                height: '80%',
                objectFit: 'contain',
                display: 'block',
            }}
        />
    )
}

export default MatxLogo
